
import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import ApiEndpoints from "../../../constants/api_endpoints";
import "../../../styles/button.css"
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import TablePagination from "@material-ui/core/TablePagination";

class JobLogs extends Component {
    constructor(props) {
      super(props);
      this.state = {
           logsData: [],
           logsCount: 0,
           currentPage: 0,
           rowsPerPage: 10
        }
    }

    async componentDidMount(){
        await this.fetchJobLogs();
    }

    fetchJobLogs = async (page = 0, rowsPerPage = this.state.rowsPerPage) => {
        let { job } = this.props;
        store.dispatch(setLoader(true))
        let body = { job_id: job.job_id, limit: rowsPerPage, offset: page * rowsPerPage }
        try {
            let apiData = await ApiEndpoints.Jobs.fetchJobLogs(body);
            this.setState({ logsData: apiData.data.data.rows || [], logsCount: apiData.data.data.count || 0, currentPage: page, rowsPerPage })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

    render(){
        let { logsData, logsCount, currentPage, rowsPerPage } = this.state;
        return (
            <div className="px-3">
                <Row className="border-bottom">
                    <Col xs={6}><h6>Log</h6></Col>
                    <Col xs={3}><h6>By</h6></Col>
                    <Col xs={3}><h6>Date</h6></Col>
                </Row>
                {logsData.length ?
                    logsData.map((log, i) =>
                        <Row key={i} className="py-2 border-bottom">
                            <Col xs={6}>
                                <span style={{ fontSize: 12 }}>
                                    {log.entity_type === "PREV_CLIENT"
                                        ? `${log.entity_type_label} : ${log.Client ? log.Client.client_name : log.entity_value} → ${log.NewClient ? log.NewClient.client_name : "-"}`
                                        : `${log.entity_type_label} : ${log.entity_display_value}`}
                                </span>
                            </Col>
                            <Col xs={3} style={{ fontSize: 12 }}>{log.CreatedByUser ? log.CreatedByUser.first_name : log.created_by}</Col>
                            <Col xs={3} style={{ fontSize: 12 }}>{moment(log.created_on).utcOffset("+05:30").format("Do MMM'YY hh:mm A")}</Col>
                        </Row>
                    )
                    :
                    <em className="d-block m-3">No Data</em>
                }
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={logsCount}
                    rowsPerPage={rowsPerPage}
                    page={currentPage}
                    onChangePage={(e, page) => this.fetchJobLogs(page, rowsPerPage)}
                    onChangeRowsPerPage={(e) => this.fetchJobLogs(0, parseInt(e.target.value))}
                />
            </div>
        );
    }
}

export default JobLogs;
